import { z } from 'zod'

/**
 * Simple email-shape check. Authoritative validation is done by Supabase Auth
 * on the server; this is for fast UI feedback and shared schema reuse.
 *
 * Matches `local@domain.tld` with no whitespace. Does not validate IDN,
 * quoted local parts, or RFC 5322 edge cases — Supabase rejects those anyway.
 */
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export function isValidEmail(value: string): boolean {
  return EMAIL_REGEX.test(value)
}

export const emailSchema = z
  .string()
  .trim()
  .refine(isValidEmail, { message: 'Invalid email address' })
